import { styled, lighten } from "@mui/material/styles";
import { DialogContent, Typography, Grid } from "@mui/material";

export const Content = styled(DialogContent)(({ theme }) => ({
  borderTop: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderBottom: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
}));

export const Container = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "10px",
});

export const RadioGroupContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  margin: "0px 20px",
});

export const ContentText = styled(Typography)({
  fontWeight: "bold",
});
